(function() {
    'use strict';

    angular
        .module('app.directive')
        .directive('taiMetro', taiMetro);

    function taiMetro() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: ControllerController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            templateUrl: 'directive/taiMetro.html',
            scope: {
                data: '='
            }
        };
        return directive;

        function link() {}
    }
    /* @ngInject */
    function ControllerController(menuService,$scope) {
        var vm = this;
        // 1.8.2 父層參數 data  無法直接從 scope 引入
        vm.data = $scope.$parent.vm.data;
        vm.redirectUrl = redirectUrl;
        vm.view = {
            isLogin: sessionStorage.getItem('token')
        };

        function redirectUrl(item) {

            //console.log("item.menuSerilNo:"+item.menuSerilNo);
            if (!_.isEmpty(sessionStorage.getItem('menuAllList'))){

                sessionStorage.setItem('menuSerilNo', '');
                sessionStorage.setItem('menuItemPath', '');
                
                //如果Menu=37(上課與證照)，就設定Menu=-9901(待修課程)
                if (parseInt(item.menuSerilNo)===37){
                   sessionStorage.setItem('menuSerilNo', -9901);
                }
                else{
                   sessionStorage.setItem('menuSerilNo', item.menuSerilNo);
                }

                //點選任一動態磚即撈取是選單功能Menu資料
                var menuAllList = JSON.parse(sessionStorage.getItem('menuAllList')); 
                var menuItems = menuAllList.filter(function (menuLists){
                    return (parseInt(menuLists.menuSerilNo) === parseInt(sessionStorage.getItem('menuSerilNo')) &&
                            menuLists.hasChild === false
                    );
                });
                //設定MenuSerilNo / MenuItemPath，以便點選三明治時會自動帶停駐在目前選單位置
                if (menuItems!==null && menuItems.length!==0){
                    sessionStorage.setItem('menuSerilNo', menuItems[0].menuSerilNo);
                    sessionStorage.setItem('menuItemPath', menuItems[0].menuItemPath);
                }
                else{
                    //如是選單節點即撈取第二或第三階層是否為父階層 
                    menuItems = menuAllList.filter(function (menuLists) {
                        return (parseInt(menuLists.parentId) === parseInt(sessionStorage.getItem('menuSerilNo'))
                        );
                    });

                    //撈取選單節點下排序第一個功能Menu
                    if (menuItems != null && menuItems.length!==0){                    
                        var sort = Math.min(...menuItems.map(p => p.sort));
                        var menuItem = menuItems.filter(function (menuLists) {
                            return (parseInt(menuLists.sort) === parseInt(sort));
                        });
                    
                        //設定MenuSerilNo / MenuItemPath，以便點選三明治時會自動帶停駐在目前選單位置
                        //console.log(menuItem);
                        if (menuItem!==null && menuItem.length!==0){
                            if (!menuItem[0].hasChild){
                                sessionStorage.setItem('menuSerilNo', menuItem[0].menuSerilNo);
                            }
                            sessionStorage.setItem('menuItemPath', menuItem[0].menuItemPath);
                        }                    
                    }
                }

                // console.log('taiMetro_redirectUrl-menuSerilNo:'+sessionStorage.getItem('menuSerilNo'));
                // console.log('taiMetro_redirectUrl-menuItemPath:'+sessionStorage.getItem('menuItemPath'));
            }

            menuService.redirectUrl(item);
        }
    }
    
})();